<template>
  <RateDetailTable
    :header="t('common.paramInformation', { param: t('common.insurance') })"
    :value="insuranceInformation"
  />
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { renderDateTime, renderMoney } from '@rygen/rygen-ui/i18n';

import { RateQuote } from '@/model';

import RateDetailTable, {
  RateQuoteDetails,
} from '@/components/rateShop/expandedDetails/RateDetailTable.vue';

const props = defineProps({
  rateQuote: {
    type: RateQuote,
    default: () => new RateQuote(),
  },
});
const { rateQuote } = toRefs(props);

const { t } = useI18n();

const insuranceInformation = computed(() => {
  return collectInsuranceInformation(rateQuote.value);
});

const collectInsuranceInformation = (
  rateQuote: RateQuote,
): RateQuoteDetails[] => {
  const information: RateQuoteDetails[] = [];
  const insuranceInformation = rateQuote.carrier?.insuranceInformation;

  information.push({
    k: t('carriers.insurance.cargoCoverageAmount'),
    v: renderMoney(insuranceInformation?.cargoInsuranceCoverage?.amount),
  });
  information.push({
    k: t('carriers.insurance.cargoExpirationDate'),
    v: renderDateTime(insuranceInformation?.cargoInsuranceExpiration, {
      timeFormat: 'NONE',
    }),
  });
  information.push({
    k: t('carriers.insurance.liabilityCoverageAmount'),
    v: renderMoney(insuranceInformation?.liabilityInsuranceCoverage?.amount),
  });
  information.push({
    k: t('carriers.insurance.liabilityExpirationDate'),
    v: renderDateTime(insuranceInformation?.liabilityInsuranceExpiration, {
      timeFormat: 'NONE',
    }),
  });
  information.push({
    k: t('carriers.insurance.freightBrokerBondAmount'),
    v: renderMoney(insuranceInformation?.freightBrokerBondAmount?.amount),
  });
  information.push({
    k: t('carriers.insurance.freightBrokerBondDate'),
    v: renderDateTime(insuranceInformation?.freightBrokerBondStartDate, {
      timeFormat: 'NONE',
    }),
  });

  return information;
};
</script>
